module.exports = __webpack_public_path__ + "static/media/cauldronOnly.8ff6e30a.gif";